<template>
    <svg style="display: none;">
        <symbol id="bridge" viewBox="0 0 240 743">
            <path d="M0 5H240" stroke="#00A4FF" stroke-width="2"/>
        </symbol>
    </svg>
</template>
